export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6565.7c9d23f2.jpg";